import { get, post, remove } from 'api.vanilla.service';
import { formatErrorMessage } from 'api/helpers';
import { set as setFeedback } from 'feedback.vanilla.service.js';

/**
 * @function fetchAllProductBundleTranslations
 */
export function fetchAllProductBundleTranslations(id, state) {
	const preFilter = `:bundle.id=='${id}'`;
	const filter = state.filter ? `${preFilter};${state.filter}` : preFilter;

	// Set params and filter
	const params = {
		limit: state.limit,
		sort: state.sort,
		offset: state.offset,
		filter,
	};

	return get(`/product/bundle_translations`, params, null, state.headers)
		.then((res) => {
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
		});
}

/**
 * @function addProductBundleTranslations
 * @description add
 */
export function addProductBundleTranslations(data) {
	return post(`/product/bundle_translations`, data)
		.then((res) => {
			setFeedback('Product bundle translation added', 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function editProductBundleTranslations
 */
export function editProductBundleTranslations(data) {
	return post(`/product/bundle_translations/${data.id}`, data)
		.then((res) => {
			setFeedback('Product bundle translation edited', 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function deleteProductBundleTranslation
 */
export function deleteProductBundleTranslation(id) {
	return remove(`/product/bundle_translations/${id}`)
		.then((res) => {
			setFeedback('Product bundle translation deleted', 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}
